<section class="public-section links-page">
  <header class="public-page-header">
    <h2 class="public-page-title">Links</h2>
    <p class="public-page-subtitle">Estes são os links que mais visito e os meus favoritos</p>
  </header>

  <div class="row">
    @for (link of links; track link) {
      <div class="col-sm-12 col-md-6 col-lg-6">
        <div class="card mb-3" style="max-width: 540px;">
          <div class="row no-gutters align-items-center">
            <div class="col-md-4 text-center">
              <img src="{{ link.imagem }}" class="card-img mx-auto d-block" alt="{{ link.site }}"
                style="max-width: 100px;">
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h3 class="card-title">{{ link.site }}</h3>
                <p class="card-text">{{ link.descricao }}</p>
                <a href='{{ link.url }}' target="_blank" class="card-link">Acesse</a>
              </div>
            </div>
          </div>
        </div>
  </div>
    }
  </div>
  <div class="text-center pt-4">
    <small>
      *Alguns textos foram aleatoriamente retirados de sites de terceiros.
    </small>
  </div>
</section>